// eslint-disable-next-line import/prefer-default-export
export const getOptions = (data) => {
  if (!data?.length) return undefined;

  return data?.map((item) => ({ value: item._id, label: item.name }));
};
